import React from "react";

export default (props) => {

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="39"
            height="39"
            fill="none"
            viewBox="0 0 39 39"
            {...props}
        >
            <path fill="#fff"
                  d="M32.5 0h-26A6.508 6.508 0 000 6.5v26C0 36.084 2.916 39 6.5 39h26c3.584 0 6.5-2.916 6.5-6.5V26a1.626 1.626 0 00-3.25 0v6.5a3.253 3.253 0 01-3.25 3.25h-26a3.253 3.253 0 01-3.25-3.25v-26A3.253 3.253 0 016.5 3.25h26a3.253 3.253 0 013.25 3.25V13A1.626 1.626 0 0039 13V6.5C39 2.916 36.084 0 32.5 0z"/>
            <path fill="#fff"
                  d="M32.5 19.5c0-.897-.728-1.625-1.625-1.625H12.047l3.727-3.726a1.625 1.625 0 00-2.298-2.298l-6.5 6.5a1.625 1.625 0 000 2.298l6.5 6.5c.318.317.733.476 1.149.476a1.625 1.625 0 001.149-2.774l-3.726-3.726h18.827c.897 0 1.625-.728 1.625-1.625z"/>
        </svg>
    );
}
